import Dropdown from '../Dropdown/Dropdown';
import { ReactComponent as ArrowIcon } from '../../icons/select-chevron.svg';
import './DatePicker.scss';
import DatePickerCalendar from './DatePickerCalendar';
import classNames from 'classnames';
import { formatDate } from '../../core/helpers';
import { useTranslation } from 'react-i18next';
import Button from '../Button';

interface Props {
  selectedDate?: Date | undefined;
  onSelect: (d: Date | undefined) => void;
  initialDate?: Date;
  name?: string;
  label?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  horizontalAlignment?: 'left' | 'right';
  direction?: 'up' | 'down';
  error?: string;
  touched?: boolean;
  deletable?: boolean;
}

export default function DatePicker({
  selectedDate,
  onSelect,
  initialDate,
  name,
  label,
  className = '',
  placeholder = 'Select date',
  horizontalAlignment = 'left',
  disabled,
  direction = 'up',
  error,
  touched,
  deletable,
}: Props) {
  const handleSelect = (toggleDropdown: () => void) => (d: Date) => {
    onSelect(d);
    toggleDropdown();
  };

  const { t } = useTranslation();
  return (
    <div className={`${className} position-relative`}>
      {!!label && <div className='mb-2 DatePicker__label'>{label}</div>}
      <div className='d-flex align-items-center'>
        <Dropdown
          isDisabled={disabled}
          direction={direction}
          className={classNames('DatePicker', {
            'DatePicker--invalid': !!error && touched,
          })}
          data-testid={name ? name : undefined}
          trigger={
            <div className='w-100 d-flex justify-content-between align-items-center'>
              <span className='text-start text-truncate'>
                {selectedDate
                  ? formatDate(selectedDate, 'dd.MM.yyyy')
                  : t(placeholder)}{' '}
              </span>
              <ArrowIcon />
            </div>
          }
          content={(toggleDropdown) => (
            <>
              <DatePickerCalendar
                initialDate={initialDate}
                selectedDate={selectedDate}
                onSelect={handleSelect(toggleDropdown)}
                name={name ? `${name}-calendar` : undefined}
              />
              {deletable && (
                <div className='ps-2 ms-1'>
                  <Button
                    styling='naked-blue'
                    onClick={() => {
                      onSelect(undefined);
                      toggleDropdown();
                    }}
                  >
                    Clear
                  </Button>
                </div>
              )}
            </>
          )}
          horizontalAlignment={horizontalAlignment}
        />
      </div>
      {touched && error && (
        <div
          className='DatePicker__error'
          data-testid='trespassing_delivery_threshold_date-error'
        >
          {error}
        </div>
      )}
    </div>
  );
}
